// src/components/gestionEvento/formsAjustes/InformacionContactoForm.js

import React from 'react';
import PropTypes from 'prop-types'; // Importar PropTypes
import { Grid, TextField, Button, IconButton, Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const InformacionContactoForm = ({
  contactos = [], // Valor por defecto: array vacío
  onChange,
  onAddContacto,
  onDeleteContacto,
}) => {
  const sectionSx = {
    '& .MuiOutlinedInput-root': { borderRadius: 2 },
  };

  return (
    <Box sx={sectionSx}>
      {/* Verificar si contactos es un array antes de mapear */}
      {Array.isArray(contactos) && contactos.map((contacto, index) => (
        <Box
          // Usar un ID si el contacto lo tuviera, si no, index es aceptable aquí
          // key={contacto.id || index}
          key={index}
          sx={{
            mb: 2,
            p: 2,
            border: '1px solid',
            borderColor: 'divider', // Usar color del tema
            borderRadius: 2,
            position: 'relative',
          }}
        >
          <Grid container spacing={2} disableEqualOverflow alignItems="center">
            {/* Nombre */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="Nombre Contacto"
                name={`contacto-${index}-nombre`} // Name único para accesibilidad/testing
                fullWidth
                // Usar optional chaining y valor por defecto por si contacto es undefined/null
                value={contacto?.nombre ?? ''}
                // Pasar index, nombre del campo ('nombre'), y valor
                onChange={(e) => onChange(index, 'nombre', e.target.value)}
                variant="outlined"
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} sm={4}>
              <TextField
                label="Email Contacto"
                name={`contacto-${index}-email`}
                type="email" // Ayuda a la validación del navegador
                fullWidth
                value={contacto?.email ?? ''}
                onChange={(e) => onChange(index, 'email', e.target.value)}
                variant="outlined"
              />
            </Grid>

            {/* Teléfono */}
            <Grid item xs={12} sm={3}>
              <TextField
                label="Teléfono Contacto"
                name={`contacto-${index}-telefono`}
                type="tel" // Ayuda con teclados móviles
                fullWidth
                value={contacto?.telefono ?? ''}
                onChange={(e) => onChange(index, 'telefono', e.target.value)}
                variant="outlined"
              />
            </Grid>

            {/* Botón de eliminación */}
            <Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/* Mostrar botón solo si hay más de un contacto */}
              {contactos.length > 1 && (
                <IconButton
                  color="error"
                  onClick={() => onDeleteContacto(index)}
                  aria-label={`Eliminar contacto ${index + 1}`} // Label más descriptivo
                  size="small" // Hacer botón consistente
                >
                  <DeleteIcon fontSize="small"/>
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Box>
      ))}

      {/* Botón para añadir contacto */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <Button
          variant="text"
          color="primary"
        onClick={onAddContacto}
          startIcon={<AddIcon />}
          disabled={!Array.isArray(contactos) || contactos.length >= 3}
        >
          Añadir contacto
        </Button>
      </Box>

      {/* Mensaje de límite */}
      {Array.isArray(contactos) && contactos.length >= 3 && (
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
          Máximo 3 contactos permitidos.
        </Typography>
      )}
    </Box>
  );
};

// Definir PropTypes
InformacionContactoForm.propTypes = {
  contactos: PropTypes.arrayOf(PropTypes.shape({
    nombre: PropTypes.string,
    email: PropTypes.string,
    telefono: PropTypes.string,
    // id: PropTypes.string, // Si tuvieran un ID único
  })),
  onChange: PropTypes.func.isRequired,
  onAddContacto: PropTypes.func.isRequired,
  onDeleteContacto: PropTypes.func.isRequired,
};

export default InformacionContactoForm;
